import React from 'react';

interface IProps {
  style?: any;
}

const shapeIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="7" height="17" viewBox="0 0 7 17" fill="none" xmlns="http://www.w3.org/2000/svg"  style={props.style}>
      <rect x="0.5" y="0.5" width="6" height="16" stroke="#122442"/>
    </svg>

  )
}

export default shapeIcon;